import httpApi from '@/utils/http-api'
import { api } from '@/config'

export default {
  getMissionDetail: () => {
    return httpApi.getDataViaApi({
      url: api.mission.getMissionDetail
    })
  }
}
